import { fetchTransactions } from "../../features/transaction/transactionThunk";
import Transaction from "./Transaction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Search from "../ui/Search";
import Filter from "../ui/Filter";
import Pagination from "../ui/Pagination";

const TransactionList = () => {
	const dispatch = useDispatch();

	const { isLoading, isError, transactions } = useSelector(
		(state) => state.transaction
	);
	const { search, currentPage, sortBy } = useSelector((state) => state.filters);

	useEffect(() => {
		dispatch(fetchTransactions({search, currentPage, sortBy}));
	}, [dispatch, search, currentPage, sortBy]);

	let content = null;
	if (isLoading) {
		content = <p className="">Loading</p>;
	}

	if (!isLoading && isError) {
		content = <p className="">There was an error occured!</p>;
	}

	if (!isLoading && !isError && transactions?.length > 0) {
		content = transactions.map((transaction) => (
			<Transaction key={transaction.id} transaction={transaction} />
		));
	}
	if (!isLoading && !isError && transactions?.length === 0) {
		content = <p className="">No transaction found!</p>;
	}

	return (
		<div className="flex justify-center items-center sm:drop-shadow-lg pt-5">
			<div className="w-full md:w-2/3 lg:w-1/2 xl:w-2/4 2xl:w-1/3 p-4 md:p-6 pb-4 mb-4 bg-white border space-y-6">
				<h2 className="text-lg sm:text-xl border-b border-b-200 pb-2">
					All Transactions
				</h2>

				<div className="flex flex-col md:flex-row gap-3 md:gap-0 justify-between">
					<Search />
					<Filter />
				</div>

				<div className="space-y-4">{content}</div>

				<Pagination />
			</div>
		</div>
	);
};

export default TransactionList;
